// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 151 ? "wheel-preview" : chunkId) + "." + {"151":"32a9b000","321":"2acdbe6c","763":"2acdbe6c"}[chunkId] + ".chunk.css";
};